import React, { useEffect, useState } from "react";
import { withTitle, withAuth } from "../../HoC";

import style from "./device.module.scss";

import { socketManager } from "../../services/socketService/socketManager";
import { connect } from "react-redux";
import { generateUniqueId } from "../../utils/uuid4";
import { withMessageOverlay } from "../../HoC/withTimeoutOverlay";
import { postRequest } from "../../services/Requests";

import izy_logo from "../../assets/iziq_full.png";
import { Footer } from "../../Components/Footer/Footer";
import { translate } from "../../translations/translate";
import { Header } from "../../Components/Header/Header";
import { compose } from "redux";

export const DevicePage = (props) => {

  const {
    socketReducer,
    match,
    devices = [],
    actions,
  } = props;

  const {
    remaining,
    isConnected,
    maxReached = false,
  } = socketReducer;

  const {
    id: deviceId,
  } = devices.find((e) => e.uuid === match.params.deviceId) || {};

  if (!deviceId) {
    props.history.push("/admin");
  }

  const [ result, setResult ] = useState<{ isOpen: boolean, loading: boolean, data: any }>({ isOpen: false, loading: false, data: {} });

  const registerBooking = () => {
    setResult({ isOpen: true, loading: true, data: {} });
    postRequest({
      url: `register/${deviceId}`,
      body: {
        email: "",
        timeOffset: 600000,
      },
    }).then(({ data }: any) => {
      setResult({ isOpen: true, loading: false, data });
      setTimeout(() => {
        setResult({ isOpen: false, loading: false, data: {}});
      }, 4000);
    }).catch((er) => {
      console.log(er);
    });
  };

  useEffect(() => {
    const randomId = generateUniqueId();
    socketManager.init({ deviceId, uid: randomId });
    return () => socketManager.close();
  }, []);

  const classNames = (item) => {
    return `${style["section"]} ${item ? style["danger"] : ""}`;
  };

  return (<div className={style["wrapper"]}>
    <Header />
    <section className={classNames(maxReached)}>
      { maxReached ?
        (<>
        <h1 className={style["text"]}>
          {translate("max-capacity")}
        </h1>
        <h1 className={style["text"]}>
          {translate("wait")}
        </h1>
        </>) : (
        <>
        <h1 className={style["text"]}>
          {translate("access-to")}
        </h1>
        <h1 className={style["numba"]}> {remaining} </h1>
        <h1 className={style["text"]}>
          {translate(`person.${remaining > 1 ? "mult" : "sing"}`) }
        </h1>
        </>
      )}

    </section>
    <Footer isConnected={isConnected} />
  </div>);
};

const mapStateToProps = (state: { deviceReducer: any, socketReducer: any, adminReducer: any, languageSelector: any }) => ({
  deviceReducer: state.deviceReducer,
  socketReducer: state.socketReducer,
  devices: state.adminReducer.devices,
});

export default compose(
  withTitle(translate("gate")),
  withAuth(0),
  connect(mapStateToProps),
  withMessageOverlay(
    translate("out-of-service"),
    translate("out-of-service-temp"),
  ),
)(DevicePage);
